import { FeatureFlagKeys } from '@modules/FeatureFlagModule/featureFlagKeys';
import useFeatureFlag from '@modules/FeatureFlagModule/hooks/useFeatureFlag/useFeatureFlag';
import useBookingRetentionEnabled from './useBookingRetentionEnabled';

/**
 * React counterpart of `InboxModule.isNewAssignedToMeUiEnabled()`.
 */
export default function useNewAssignedToMeUiEnabled(): boolean {
  const isReleased = !!useFeatureFlag(
    FeatureFlagKeys.featureAssignedToMeManualBookings,
    { defaultValue: false },
  );
  const isAgentInboxForCallsEnabled = !!useFeatureFlag(
    FeatureFlagKeys.featureEnableAgentInboxForCalls,
    { defaultValue: false },
  );
  const isRetentionEnabled = useBookingRetentionEnabled();
  return isReleased && isAgentInboxForCallsEnabled && isRetentionEnabled;
}
